import {
  Stack,
  IconButton,
  Menu,
  useTheme,
  useMediaQuery,
  Box,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import Granularity from "../../../componentes/granularity";
// componente existente
import SettingsIcon from "@mui/icons-material/Settings";
import { useFilters } from "../../../context/filterContext";

interface GranularityControlsProps {
  hasKeyOption?: { label: string; value: string }[]; // Define the type for hasKeyOption
  hasGranularity?: boolean;
  keysOptions?: string;
  setKeysOptions?: (value: string) => void;
  intervalStateCard?: string;
  setIntervalStateCard?: (value: string) => void;
  viewModeStateCard?: string;
  setViewModeStateCard?: (value: string) => void;
  repeatByStateCard?: string | null;
  setRepeatByStateCard?: (value: string) => void;
  graphic?: DashGraphicsCards;
}

const OptionsControls: React.FC<GranularityControlsProps> = ({
  hasKeyOption,
  hasGranularity,
  keysOptions,
  setKeysOptions,
  intervalStateCard,
  setIntervalStateCard,
  viewModeStateCard,
  setViewModeStateCard,
  repeatByStateCard,
  setRepeatByStateCard,
  graphic,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const handleClickItem = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  useEffect(() => {
    if (md) setAnchorEl(null);
  }, [md]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { filtersConfig } = useFilters();
  const renderGranularityItems = (vertical = false) => (
    <Stack
      direction={vertical ? "column" : "row"}
      gap={vertical ? 2 : 1}
      sx={vertical ? { p: 1 } : { p: 0 }}
    >
      {hasKeyOption && (
        <Granularity
          sx={{ width: "130px" }}
          label="Tipo"
          options={hasKeyOption}
          selected={keysOptions}
          setSelected={setKeysOptions}
        />
      )}
      {hasGranularity && (
        <Granularity
          sx={{ width: "130px" }}
          options={[
            { label: "mês", value: "month" },
            { label: "dia", value: "day" },
            { label: "semana", value: "week" },
          ]}
          selected={intervalStateCard}
          setSelected={setIntervalStateCard}
        />
      )}
      {hasGranularity && viewModeStateCard && (
        <Granularity
          sx={{ width: "130px" }}
          label="Modo"
          options={[
            { label: "Acumulado", value: "accumulate" },
            { label: "Linear", value: "linear" },
          ]}
          selected={viewModeStateCard}
          setSelected={setViewModeStateCard}
        />
      )}
      {graphic?.type === "repeat" && (
        <Granularity
          sx={{ width: "130px" }}
          label="Repetir por"
          options={
            filtersConfig
              ?.filter((f) => f.variable !== "date")
              .map((filter) => {
                return {
                  label: filter.label,
                  value: filter.variable,
                };
              }) || []
          }
          selected={repeatByStateCard as string | undefined}
          setSelected={setRepeatByStateCard}
        />
      )}
    </Stack>
  );
  if (!hasKeyOption && !hasGranularity && graphic?.type !== "repeat") {
    return <> </>;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        top: "10px",
        right: "10px",
      }}
    >
      <Tooltip title="Configurações">
        <IconButton
          size="small"
          sx={{
            transition: "transform 0.3s ease, color 0.3s ease",
            transform: `${Boolean(anchorEl) ? "rotate(90deg)" : ""}`,
            color: Boolean(anchorEl)
              ? theme.palette.text.disabled
              : theme.palette.text.secondary,
            "&:hover": {
              color: theme.palette.text.disabled,
              transform: "rotate(90deg)",
            },
          }}
          onClick={handleClickItem}
          // onMouseEnter={(e) => {
          //   const currentTarget = e.currentTarget;
          //   setTimeout(() => {
          //     handleClickItem({
          //       currentTarget,
          //     } as React.MouseEvent<HTMLButtonElement>);
          //   }, 100);
          // }}
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          ".MuiMenu-paper": {
            backgroundColor: theme.palette.background.card,
            borderRadius: "7px",
            boxShadow: "0px 1px 2px  #0000001a",
          },
        }}
      >
        {renderGranularityItems(true)}
      </Menu>
    </Box>
  );
};

export default OptionsControls;
